import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/checkbox/checkbox'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  
  return {
    html,
    config: {
      validators: ['mandatoryCheckbox'],
      defaultValue: 'false',
    },
  };
}
